import { render, staticRenderFns } from "./addAdjustment.vue?vue&type=template&id=6336c4cc&scoped=true"
import script from "./addAdjustment.vue?vue&type=script&lang=js"
export * from "./addAdjustment.vue?vue&type=script&lang=js"
import style0 from "./addAdjustment.vue?vue&type=style&index=0&id=6336c4cc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336c4cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6336c4cc')) {
      api.createRecord('6336c4cc', component.options)
    } else {
      api.reload('6336c4cc', component.options)
    }
    module.hot.accept("./addAdjustment.vue?vue&type=template&id=6336c4cc&scoped=true", function () {
      api.rerender('6336c4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/warehouseManagement/warehouseStock/addAdjustment.vue"
export default component.exports